
enum UserRolesEnum {
    basic = 'basic',
    customer = 'customer',
    admin = 'admin',
    stand_admin = 'stand_admin:',
    all = 'all'
}
export { UserRolesEnum };
